import { DateTime } from "luxon";

/**
 * Calculates the cutoff date for upcoming events: today + up to 2 weekdays
 * (excluding weekends), rounded to end of day.
 */
export function calculateUpcomingEventsCutoffDate({
  startDate,
}: {
  startDate: DateTime;
}): DateTime {
  let date = startDate.startOf("day");
  let weekdaysAdded = 0;

  for (let days = 1; weekdaysAdded < 2; days++) {
    const candidate = startDate.plus({ days }).startOf("day");
    const weekday = candidate.weekday; // 1 = Monday, 7 = Sunday
    const isWeekend = weekday === 6 || weekday === 7; // Saturday or Sunday
    if (!isWeekend) weekdaysAdded++;
    date = candidate;
  }

  return date.endOf("day");
}

/**
 * Human-readable day label for the cutoff date (e.g. "Today", "Tomorrow", "Monday").
 */
export function getCutoffDayName({ cutoffDateTime }: { cutoffDateTime: DateTime }): string {
  const now = DateTime.now();
  if (cutoffDateTime.hasSame(now, "day")) return "Today";
  if (cutoffDateTime.hasSame(now.plus({ days: 1 }), "day")) return "Tomorrow";
  return cutoffDateTime.toFormat("cccc"); // Full weekday name: "Monday", "Tuesday", etc.
}
